import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'includes',
})
export class IncludesPipe implements PipeTransform {
  transform(values: unknown[], searchingValue: string): boolean {
    return values.includes(searchingValue);
  }
}

@NgModule({
  declarations: [IncludesPipe],
  exports: [IncludesPipe],
  providers: [IncludesPipe],
  imports: [CommonModule],
})
export class IncludesPipeModule {}
